/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Payout_BlockedInputs */



/**
* | output |
* | --- |
* | "Payout blocked" |
*
* @param {Partner_Admin_Commission_Payout_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_payout_blocked = /** @type {((inputs?: Partner_Admin_Commission_Payout_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Payout_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auszahlung blockiert")
	return /** @type {LocalizedString} */ ("Payout blocked")
});